import { examAdminOpenApiClient } from "../generated/client";
import type { operations } from "@airange/generated-contracts/exam";
import { unwrapOpenApiResult } from "./openapi-result";

type UserPreferencesGet = operations["get_user_preferences_api_auth_preferences_get"];
type UserPreferencesUpdatePost = operations["update_user_preferences_api_auth_preferences_post"];

export type UserPreferenceRead =
  UserPreferencesGet["responses"][200]["content"]["application/json"];
export type UserPreferenceUpdate =
  UserPreferencesUpdatePost["requestBody"]["content"]["application/json"];
export type UserPreferenceSettings = UserPreferenceUpdate["settings"];

export async function getUserPreferences(): Promise<UserPreferenceRead> {
  return unwrapOpenApiResult(await examAdminOpenApiClient.GET("/api/auth/preferences"));
}

export async function updateUserPreferences(payload: UserPreferenceUpdate): Promise<UserPreferenceRead> {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.POST("/api/auth/preferences", {
      body: payload,
    }),
  );
}

export async function resetUserPreferences(): Promise<UserPreferenceRead> {
  return unwrapOpenApiResult(await examAdminOpenApiClient.DELETE("/api/auth/preferences"));
}
